import { render, staticRenderFns } from "./JVxeCheckboxCell.vue?vue&type=template&id=37de573a&"
import script from "./JVxeCheckboxCell.vue?vue&type=script&lang=js&"
export * from "./JVxeCheckboxCell.vue?vue&type=script&lang=js&"
import style0 from "./JVxeCheckboxCell.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37de573a')) {
      api.createRecord('37de573a', component.options)
    } else {
      api.reload('37de573a', component.options)
    }
    module.hot.accept("./JVxeCheckboxCell.vue?vue&type=template&id=37de573a&", function () {
      api.rerender('37de573a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JVxeTable/components/cells/JVxeCheckboxCell.vue"
export default component.exports